/* Original "It's Funky Baby" mark: a funky-house vinyl with a smiley label */
export function Mark({ size = 44, className = '', spin = false }) {
  return (
    <svg
      viewBox="0 0 64 64"
      width={size}
      height={size}
      className={`${spin ? 'animate-spin-slow' : ''} ${className}`}
      role="img"
      aria-label="It's Funky Baby — smiley vinyl logo"
      data-testid="ifb-logo-mark"
    >
      <circle cx="32" cy="32" r="30" fill="#E8B86A" />
      <circle cx="32" cy="32" r="24" fill="none" stroke="#211A1F" strokeWidth="1.6" opacity="0.35" />
      <circle cx="32" cy="32" r="19" fill="none" stroke="#211A1F" strokeWidth="1.6" opacity="0.25" />
      <circle cx="32" cy="32" r="14" fill="#D3A6CF" />
      <circle cx="26.4" cy="29.2" r="2.3" fill="#211A1F" />
      <circle cx="37.6" cy="29.2" r="2.3" fill="#211A1F" />
      <path
        d="M25 34.2c1.8 3 4.2 4.6 7 4.6s5.2-1.6 7-4.6"
        fill="none"
        stroke="#211A1F"
        strokeWidth="2.6"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function TikTokIcon({ size = 16, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
      <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 1 1-2.31-2.83v-3.5a6.37 6.37 0 1 0 5.76 6.33V8.69a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.12z" />
    </svg>
  );
}

export function PlayDisc({ className = '', size = 76 }) {
  return (
    <span
      className={`inline-flex items-center justify-center rounded-full bg-gold text-plum shadow-[0_8px_30px_rgba(0,0,0,0.35)] ${className}`}
      style={{ width: size, height: size }}
    >
      <svg width={size * 0.4} height={size * 0.4} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <polygon points="7 4 20 12 7 20 7 4" fill="currentColor" />
      </svg>
    </span>
  );
}
